import { render, staticRenderFns } from "./ArrowUpDown.vue?vue&type=template&id=63da8204&"
import script from "./ArrowUpDown.vue?vue&type=script&lang=js&"
export * from "./ArrowUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63da8204')) {
      api.createRecord('63da8204', component.options)
    } else {
      api.reload('63da8204', component.options)
    }
    module.hot.accept("./ArrowUpDown.vue?vue&type=template&id=63da8204&", function () {
      api.rerender('63da8204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/ArrowUpDown.vue"
export default component.exports